import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { useNavigate } from "react-router-dom";

// Import logo images for various color themes
import nav_home_logo from "../../../../icons/nav_home_logo.svg"
import fr_black_white from "../../../../assets/images/logo/fr_black_white.svg"
import fr_green from "../../../../assets/images/logo/fr_green.svg"
import fr_yellow from "../../../../assets/images/logo/fr_yellow.svg"
import fr_purple from "../../../../assets/images/logo/fr_purple.svg"
import fr_violet from "../../../../assets/images/logo/fr_violet.svg"

// Import default square image as fallback
import { useWallet } from "../../../../context/WalletContextProvider";

const Header = ({ data }) => {
  const { account } = useWallet()
  const navigate = useNavigate()
  const { imageBuffer } = data;

  // Helper function to convert image buffer to binary string
  const bufferToBinaryString = (buffer) => {
    return String.fromCharCode(...new Uint8Array(buffer.data));
  }

  // Convert each imageBuffer item to a binary string (used to embed as base64)
  const binaryImages = {
    ct_icon_1: bufferToBinaryString(imageBuffer.ct_icon_1),
    ct_icon_2: bufferToBinaryString(imageBuffer.ct_icon_2),
    ct_icon_3: bufferToBinaryString(imageBuffer.ct_icon_3),
    ct_icon_4: bufferToBinaryString(imageBuffer.ct_icon_4),
    ct_icon_5: bufferToBinaryString(imageBuffer.ct_icon_5),
    ct_icon_6: bufferToBinaryString(imageBuffer.ct_icon_6),
  };


  // Function to close the side navigation menu
  const closeMenu = () => {
    document.getElementById("sidenav").style.width = "0px";
  };

  // Function to handle logo click - return to previous page based on context
  const handleLogoClick = (e) => {
    e.preventDefault();

    const previewSource = sessionStorage.getItem('previewSource');
    const previewContext = sessionStorage.getItem('previewContext');
    const previewReturnUrl = sessionStorage.getItem('previewReturnUrl');
    const campaignId = sessionStorage.getItem('previewCampaignId');
    const createMode = sessionStorage.getItem('previewCreateMode');
    const formDraft = sessionStorage.getItem('previewFormDraft');

    if (previewSource === 'sponsor' && previewContext === 'navbar') {
      // Sponsor navbar preview - return to where user was before previewing
      navigate(previewReturnUrl || '/sponsor');
    } else if (previewSource === 'sponsor' && previewContext === 'campaign-form') {
      // Sponsor campaign form preview - return to campaign form
      if (campaignId) {
        navigate(`/sponsor/campaign`, { state: { editCampaignId: campaignId } });
      } else if (createMode && formDraft) {
        navigate(`/sponsor/campaign`, { state: { createMode: true, formDraft: formDraft } });
      } else {
        navigate('/sponsor/campaign');
      }
    } else if (previewSource === 'artist' && previewContext === 'navbar') {
      // Artist navbar preview - return to where user was before previewing
      navigate(previewReturnUrl || '/artist');
    } else {
      // Fallback to external Fundraisin website
      window.open(process.env.REACT_APP_FUNDRAISIN_WEBSITE_LINK, '_blank');
    }
  };

  return (
    <header style={{ backgroundColor: data.web_main_color }}>
      {/* Main navigation bar */}
      <nav className="navbar-desktop" style={{ backgroundColor: data.web_main_color }}>
        <div className="nav__mobile-box">
          {/* Logo - clickable to return to previous page */}
          <a
            href="#"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          >
            <img
              className="nav__logo"
              src={
                data.ct_main_logo === "yellow" ? fr_yellow :
                  data.ct_main_logo === "green" ? fr_green :
                    data.ct_main_logo === "purple" ? fr_purple :
                      data.ct_main_logo === "violet" ? fr_violet :
                        data.ct_main_logo === "black_white" ? fr_black_white :
                          nav_home_logo
              }
              alt="logo"
            />
          </a>
        </div>

        {/* Desktop menu items */}
        <div className="nav__menu-box">
          <ul className="nav__menu-items">
            {/* Link items with icons */}
            {[
              { path: "/preview-home/#home", label: "Home", icon: "ct_icon_1" },
              { path: "/preview-home/#top", label: "Top", icon: "ct_icon_2" },
              { path: "/preview-home/#my", label: "My", icon: "ct_icon_3" },
              { path: "/preview-home/#about", label: "About", icon: "ct_icon_4" },
              { path: "/preview-home/mint", label: "Mint", icon: "ct_icon_5" },
              { path: "/preview-home/buy", label: "Buy", icon: "ct_icon_6" }
            ].map(({ path, label, icon }) => (
              <Link
                to={path}
                smooth
                offset={-70}
                duration={500}
                className="nav__menu-item-box"
                key={label}
              >
                <li className="nav__menu-item" style={{ color: data.light_text_color }}>{label}</li>
                {imageBuffer[icon] ? (
                  <img
                    src={`data:image/svg+xml;base64,${btoa(binaryImages[icon])}`}
                    className="nav__menu-item-icon"
                    alt={label.toLowerCase()}
                  />
                ) : (
                  <div className="nav__menu-item-icon-dots" style={{backgroundColor: data.ct_main_logo === "yellow" ? "#FCDB04" : data.ct_main_logo === "purple" ? "#B4519E" : data.ct_main_logo === "violet" ? "#8166AD" : data.ct_main_logo === "green" ? "#70C6A4" : data.ct_main_logo === "black_white" ? "#fff" : "#FCDB04"}}></div>
                )}
              </Link>
            ))}

            {/* Wallet address display */}
            <span className="nav__menu-item-box">
              <li className="nav__menu-item nav__menu-item-btn">
                <div className="nav__menu-item-btn-info">
                  <span className="wallet-addr" style={{ color: data.light_text_color }}>
                    {account ? `${account.slice(
                      0,
                      6
                    )}...${account.slice(
                      account.length - 4
                    )}` : "Connect Your Wallet"}
                  </span>
                </div>
              </li>
            </span>
          </ul>
        </div>

        {/* Side navigation menu for mobile */}
        <div id="sidenav" className="nav__menu-box">
          <button className="closebtn" onClick={closeMenu}>
            &times;
          </button>
          <ul className="nav__menu-items">
            {[
              { path: "/#home", label: "Home" },
              { path: "/preview-home/#top", label: "Top" },
              { path: "/preview-home/#my", label: "My" },
              { path: "/preview-home/#about", label: "About" },
              { path: "/preview-home/mint", label: "Mint" },
              { path: "/preview-home/buy", label: "Buy" }
            ].map(({ path, label }) => (
              <Link
                to={path}
                smooth
                offset={-70}
                duration={500}
                className="nav__menu-item-box"
                key={label}
              >
                <li className="nav__menu-item">{label}</li>
              </Link>
            ))}

            {/* Wallet display in the mobile menu */}
            <span className="nav__menu-item-box">
              <li className="nav__menu-item nav__menu-item-btn">
                <div className="nav__menu-item-btn-info">
                  <span className="wallet-addr">
                    {account ? `${account.slice(
                      0,
                      6
                    )}...${account.slice(
                      account.length - 4
                    )}` : "Connect Your Wallet"}
                  </span>
                </div>
              </li>
            </span>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default React.memo(Header);
